import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { ButtonOutput } from "../button-output";
import { ButtonActionsType } from "../button-actions.type";

@Component({
    selector: "app-icon-button",
    templateUrl: "./icon-button.component.html",
    styleUrls: ["./icon-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconButtonComponent {
  /**
   * Icon src that should be displayed on the button
   */
  @Input() src = "";

  /**
   * Disabled state of the button
   */
  @Input() disabled: boolean = false;

  @Input() style = {
    width: "32",
    height: "32",
  };

  @Input() addPadding: Boolean = false;

  @HostBinding("class") get hostClasses() {
    const classList = ["icon-button"];
    if (this.disabled) {
      classList.push("button--disabled");
    }
    if (this.addPadding) {
      classList.push("button--padding");
    }
    return classList;
  }

  @HostBinding("attr.role") role = "button";

  @HostBinding("attr.tabindex") get tabindex() {
    return this.disabled ? "-1" : "0";
  }

  /**
   * main button output
   */
  @Output() action: EventEmitter<ButtonOutput> =
    new EventEmitter<ButtonOutput>();

  @HostListener("click", ["$event"])
  public click(evt: Event) {
    this.action.emit({
      type: ButtonActionsType.Click,
    });
  }

  // ⚠ Der Host ist kein <button> — Enter und Leertaste loesen kein click aus.
  @HostListener("keydown", ["$event"])
  public keydown(evt: KeyboardEvent) {
    if (this.disabled || (evt.key !== "Enter" && evt.key !== " ")) {
      return;
    }

    evt.preventDefault();
    this.action.emit({ type: ButtonActionsType.Click });
  }
}
